import HouseholdSize from './HouseholdSize'

export default HouseholdSize